export const TX_STATES = Object.freeze({
  confirm: 'confirm',
  pending: 'pending',
  success: 'success',
  failed: 'failed',
  rejected: 'rejected',
  fully_matched: 'fully matched'
})



// WEBPACK FOOTER //
// ./src/js/const/tx_states.const.js